export type CommercePlatformOnboardingStatus =
  | 'ONBOARDING_STATUS_COMPLETE'
  | 'ONBOARDING_STATUS_INCOMPLETE'
  | 'ONBOARDING_STATUS_NOT_STARTED';

export type CommercePlatformAccountResponse = {
  redirectUri: string;
  spotifyAccountStatus: number;
  onboardingStatus: CommercePlatformOnboardingStatus;
};

export async function fetchCommercePlatformAccount(
  stationId: string,
  userId: number
): Promise<CommercePlatformAccountResponse> {
  const response = await fetch(
    `/api/proxy/v3/users/${userId}/spotify/commercePlatform/account?stationId=${stationId}`,
    {
      method: 'GET',
      credentials: 'same-origin',
    }
  );
  if (response.ok) {
    return response.json();
  }
  throw new Error(`Could not fetch user's commerce platform account`);
}
